import { memo, useCallback } from 'react';
import { Drawer, Button, Space, Typography, Form, Select } from 'antd';
import { Status } from '../../../../fsm/jobs';

const { Text } = Typography;
const { Option } = Select;

// Only the fit score filter is shown: it is the one filter the candidates
// endpoint applies. It also accepts statuses, mandatory skills / title match,
// max distance, missing addresses and applicants, but ignores them, so a
// control for any of those claimed a filter that was never applied. The
// payload type keeps those optional fields so a control can come back, with a
// matching backend change, without touching the page.
interface Props {
  isOpen: boolean;
  onClose: () => void;
  onApply: (filters: {
    fitScore?: number;
    statuses?: Status[];
    hasMandatorySkills?: boolean;
    hasMandatoryTitleMatch?: boolean;
    maxDistance?: number;
    candidatesWithNoLocation?: boolean;
    isApplicant?: boolean;
  }) => void;
}

const Filters = ({ isOpen, onClose, onApply }: Props) => {
  const [form] = Form.useForm();

  const handleApply = useCallback(() => {
    onApply({ fitScore: form.getFieldValue('fitScore') });
  }, [form, onApply]);

  const handleReset = useCallback(() => {
    form.resetFields();
    handleApply();
  }, [form, handleApply]);

  return (
    <Drawer
      title="Filters"
      onClose={onClose}
      open={isOpen}
      extra={
        <Space>
          <Button onClick={handleReset}>Reset</Button>
          <Button type="primary" onClick={handleApply}>
            Apply
          </Button>
        </Space>
      }
    >
      <Form
        form={form}
        layout="vertical"
        style={{ width: '100%' }}
        autoComplete="off"
      >
        <Text strong style={{ fontSize: 16 }}>
          Fitscore
        </Text>
        <Form.Item
          name="fitScore"
          label="Fitscore from"
          style={{ marginBottom: 8, marginTop: 20 }}
        >
          <Select size="large" placeholder="Select fitscore from">
            <Option value="50">50</Option>
            <Option value="55">55</Option>
            <Option value="60">60</Option>
            <Option value="65">65</Option>
            <Option value="70">70</Option>
            <Option value="75">75</Option>
            <Option value="80">80</Option>
            <Option value="85">85</Option>
            <Option value="90">90</Option>
            <Option value="95">95</Option>
            <Option value="100">100</Option>
          </Select>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default memo(Filters);
